import { RESOURCE_TYPE, COMMODITY_SCENE_MODE } from "@utils/CONST"
import styles from "./index.module.scss"

const baseUrl = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/upload_require/"
const videoBaseUrl = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/"
const UPLOAD_REQUIRE_LIST = {
    [RESOURCE_TYPE.MODEL]: [{
        urls: ["model_1.jpg"],
        name: "需包含正脸照",
    }, {
        urls: ["model_2.jpg", "model_3.jpg", "model_4.jpg"],
        name: "不同角度"
    }],
    [RESOURCE_TYPE.TRYON_MODEL]: [{
        urls: ["clothes_1.jpg"],
        name: "单人，简单姿势照片"
    }, {
        urls: ["clothes_2.jpg"],
        name: "模特图衣服与商品版型一致效果更好"
    }, {
        urls: ["clothes_3.jpg"],
        name: "人物占比不可过小"
    }],
    [RESOURCE_TYPE.POSE_TRYON]: [{
        urls: ["clothes_1.jpg"],
        name: "单人，简单姿势照片"
    }, {
        urls: ["clothes_2.jpg"],
        name: "模特图衣服与商品版型一致效果更好"
    }, {
        urls: ["clothes_3.jpg"],
        name: "人物占比不可过小"
    }],
    [RESOURCE_TYPE.GLASSES_TRYON]: [{
        urls: ["clothes_1.jpg"],
        name: "单人，简单姿势照片"
    }, {
        urls: ["clothes_2.jpg"],
        name: "模特图衣服与商品版型一致效果更好"
    }, {
        urls: ["clothes_3.jpg"],
        name: "人物占比不可过小"
    }],
    [RESOURCE_TYPE.NECKLACE_TRYON]: [{
        urls: ["clothes_1.jpg"],
        name: "单人，简单姿势照片"
    }, {
        urls: ["clothes_2.jpg"],
        name: "模特图衣服与商品版型一致效果更好"
    }, {
        urls: ["clothes_3.jpg"],
        name: "人物占比不可过小"
    }],
    [RESOURCE_TYPE.SIM_TRYON]: [{
        urls: ["clothes_1.jpg"],
        name: "单人，简单姿势照片"
    }, {
        urls: ["sim_tryon.png"],
        name: "模特图衣服与商品版型一致效果更好"
    }, {
        urls: ["clothes_3.jpg"],
        name: "人物占比不可过小"
    }],
    [RESOURCE_TYPE.TRYON_SCENE]: [],
    [RESOURCE_TYPE.VIDEO_MODEL]: [{
        urls: ["video/video1.mp4", "video/video2.mp4"],
        name: "单人清晰半身/全身视频，动作连贯，勿切镜运镜"
    }],
    [RESOURCE_TYPE.COMMODITY_SCENE]: {
        [COMMODITY_SCENE_MODE.SIMILAR_STYLE]: [{
            urls: ["similar_style_1.jpg"],
            name: "商品图"
        }, {
            urls: ["similar_style_2.jpg"],
            name: "参考图"
        }, {
            urls: ["similar_style_3.jpg"],
            name: "更加自由结果"
        }],
        [COMMODITY_SCENE_MODE.SAME_STYLE]: [{
            urls: ["same_style_1.jpg"],
            name: "商品图"
        }, {
            urls: ["same_style_2.jpg"],
            name: "更加相似参考图"
        }, {
            urls: ["same_style_3.jpg"],
            name: "更加相似结果"
        }],
    }
}

export default function UploadRequirements(props) {
    const { resourceType, commoditySceneMode, size } = props
    const data = resourceType == RESOURCE_TYPE.COMMODITY_SCENE ?
        UPLOAD_REQUIRE_LIST[resourceType][commoditySceneMode] :
        UPLOAD_REQUIRE_LIST[resourceType]

    return (
        <div className={styles.UploadRequirements}>
            {
                data?.map(item => (
                    <div className={styles.Requirement}>
                        <div className={`${styles.ImageList} ${size == "small" && styles.sm}`}>
                            {
                                resourceType == RESOURCE_TYPE.VIDEO_MODEL ?
                                    <>
                                        <video className={styles.videoWrap1} src={videoBaseUrl + item.urls[0]} controls={false} autoPlay={true} loop={true}></video>
                                        <video className={styles.videoWrap2} src={videoBaseUrl + item.urls[1]} controls={false} autoPlay={true} loop={true}></video>
                                    </> :
                                    item.urls.map(url => (
                                        <img
                                            className={resourceType == RESOURCE_TYPE.VIDEO_MODEL ? styles.videoImg : ""}
                                            src={`${resourceType == RESOURCE_TYPE.VIDEO_MODEL ? videoBaseUrl : baseUrl}${url}`} />
                                    ))
                            }
                        </div>
                        <div className={`${styles.RequireName} ${size == "small" && styles.sm}`}>
                            <span>{item.name}</span>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}
